import { render, staticRenderFns } from "./Contatti.vue?vue&type=template&id=824e3cc4&scoped=true"
import script from "./Contatti.vue?vue&type=script&lang=js"
export * from "./Contatti.vue?vue&type=script&lang=js"
import style0 from "./Contatti.vue?vue&type=style&index=0&id=824e3cc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824e3cc4",
  null
  
)

export default component.exports